export const ADD_BOARD_FORM = "AddBoardForm";
export const EDIT_BOARD_FORM = "EditBoardForm";
export const SHARE_BOARD_FORM = "ShareBoardForm";
export const SHARE_BOARD_WITH_TEAM_FORM = "ShareBoardWithTeamForm";
export const CONFIRM_BOARD_DELETION_FORM = 'ConfirmBoardDeletionForm';